<template>
  <div class="park">
    <div>
    <div class="park-btn">
      <el-button type="primary" size="mini" @click="updateDicDialog()">添加数据</el-button>
    </div>
    <div class="main-table">
      <el-table
        :data="dicList"
        border
        style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.isEditable == 1">可修改</el-tag>
            <el-tag type="danger" v-else>不可修改</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建日期">
          <template slot-scope="scope">
            <div>{{$dtime(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="updateDicDialog(scope.row)" :disabled="!scope.row.isEditable">修改</el-button>
            <!--<el-button type="text" size="mini" @click="deleteDicDialog(scope.row)">{{scope.row.isDelete == true ? '恢复':'删除'}}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-bottom:30px;margin-top:20px;">
        <el-pagination
          background
          layout="total,prev, pager, next"
          :total="dataArgs.total"
          :page-size="dataArgs.take"
          :current-page="dataArgs.skip/dataArgs.take+1"
          @current-change="changePage" style="float:right;">
        </el-pagination>
      </div>
    </div>
    </div>
    <el-dialog
      title="角色操作"
      :visible.sync="isUpdateShow"
      width="70%">
      <el-form ref="form" :model="dicEntity" label-width="110px">
        <el-form-item label="ID">
          <el-input v-model="dicEntity.id"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="dicEntity.name"></el-input>
        </el-form-item>
        <el-form-item label="权限列表">
          <el-checkbox-group v-model="dicEntity.permissions">
            <el-checkbox v-for="item in permissionList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="可访问页面列表">
          <el-checkbox-group v-model="dicEntity.pages">
            <el-checkbox v-for="item in pageList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isUpdateShow = false">取 消</el-button>
        <el-button type="primary" @click="updateDic">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="!dicEntity.isDelete ? '删除字典':'恢复删除'"
      :visible.sync="isDeleteShow"
      width="50%">
      <span>确定要{{!dicEntity.isDelete ? '删除字典':'恢复删除'}}么？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDeleteShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteDic">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getUserDictionaries,getPermissions,getRoles,updateRole} from './role.gql'
import gql from "graphql-tag";
export default {
  name: 'dic',
  data () {
    return {
      dicEntity:{
        id:null,
        name:null,
        isEditable:1,
        permissions:[],
        pages:[]
      },
      permissionList:[],
      pageList:[],
      dicList:null,
      dataArgs:{
        take:20,
        skip:0,
        order:'-createTime',
        count:null,
      },
      isUpdateShow:false,
      isDeleteShow:false,
    }
  },
  created(){
    this.getDicTypeList()
    this.getPermissionList();
    this.getRoleList()
    // setInterval(()=>{
      
      
      
    // },1000)
  },
  methods:{
    getRoleList(){
      this.$global.GraphqlQuery(this,getRoles,
        
        // Parameters
        this.dataArgs,
      ).then((res) => {
        this.dataArgs.total = res.total
        this.isUpdateShow = false
        this.dicList = res.data
      })
    },
    getPermissionList(){
      this.$global.GraphqlQuery(this,getPermissions,{
        // Parameters
      }).then((res) => {
        this.permissionList = res.data
      })
    },
    updateDicDialog(item){
      if(item){
        var permissionTemp = []
        item.permissions.forEach(permission=>{
          permissionTemp.push(permission.id)
        })
        item.permissions = permissionTemp
        var pagesTemp = []
        item.pages.forEach(page=>{
          pagesTemp.push(page.id)
        })
        item.pages = pagesTemp
        this.dicEntity = item
      }else {
        this.dicEntity.id = null
      }
      this.isUpdateShow = !this.isUpdateShow
    },
    changeTypeRadio(){
      this.dataArgs.skip = 0;
      this.getRoleList()
    },
    changePage(val){
      this.dataArgs.skip = (val-1)*this.dataArgs.take
      this.getRoleList()
    },
    getDicTypeList(){
      this.$global.GraphqlQuery(this,getUserDictionaries,{
        // Parameters
       type:'page_page',order:'+sort',
      }).then((res) => {
        this.pageList = res.data
      })
    },
    updateDic(){
      let {name,isEditable,permissions,pages} = this.dicEntity
      const subEntity = {name,isEditable,permissions,pages}
      
      if(this.dicEntity.id){
        this.$global.GraphqlMutation(this,updateRole,{
          // Parameters

            id:this.dicEntity.id,
            data: subEntity
        }).then(res=>{
          this.getRoleList();
        })
      } 
    },
    deleteDicDialog(item){
      this.dicEntity = item
      this.isDeleteShow = !this.isDeleteShow
    },
    deleteDic(){
    this.$apollo.mutate({
        mutation: gql`mutation ($id: String!) {
          deleteDictionary(id: $id) {
            status
          }
        }`,
        // Parameters
        variables: {
          id: 1,
        },
      }).then((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.park{
  height: 100%;
}
.park-btn {
  margin: 10px;
}
.park-red {
  background-color: red;
  color:white;
  padding:5px;
}
.park-green{
  background-color: green;
  color: white;
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/management/Role.vue